import qs from 'qs';
import React from 'react';
import * as Yup from 'yup';
import { Form as FinalForm } from 'react-final-form';
import * as AuthAPI from 'src/services/auth';
import { ROUTES } from 'src/constants';
import { email, validate } from 'src/helpers/validation';
import Form from './Form';

const schema = Yup.object({
  company_name: Yup.string().required(),
  email,
  phone: Yup.string().required()
});

export const handleSubmitEmployer = t => async values => {
  const { emailTaken, name } = await AuthAPI.checkEmail(values);
  if (emailTaken) {
    return Promise.resolve({ email: t('Email has already been taken') });
  }
  const searchQuery = qs.stringify({
    ...values,
    company_name: name || values.company_name,
    signup_state: name ? 'as_member' : 'as_owner'
  });
  window.location.href = `${ROUTES.signUpEmployer}?${searchQuery}`;
};

const FinalFormWrapper = ({ checkEmail, employerPreSignUp, ...props }) => {
  return (
    <FinalForm
      onSubmit={handleSubmitEmployer(props.t)}
      validate={values => validate(values, schema)}
      render={Form as any}
      {...props}
    />
  );
};

export default FinalFormWrapper;
